import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

const COUNTRY_PREFIXES = {
  BJ: '229',
  SN: '221'
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    country: 'Benin',
    countryPrefix: '229',

    hospital: {
      type: '',
      name: '',
      address: '',
      email: '',
      contact: '',
      subdomain: '',
      countryCode: '229'
    },

    manager: {
      firstname: '',
      lastname: '',
      phoneNumber: '',
      countryCode: '229',
      email: ''
    },

    secretary: {
      firstname: '',
      lastname: '',
      phoneNumber: '',
      countryCode: '229',
      email: ''
    },

    registrationStep: 0
  },

  mutations: {
    COUNTRY (state, { country, countryCode }) {
      state.country = country
      state.countryPrefix = COUNTRY_PREFIXES[countryCode] || '229'
      state.hospital.countryCode = state.countryPrefix
      state.manager.countryCode = state.countryPrefix
      state.secretary.countryCode = state.countryPrefix
    },

    HOSPITAL (state, hospital) {
      state.hospital = hospital
    },

    MANAGER (state, manager) {
      state.manager = manager
    },

    SECRETARY (state, secretary) {
      state.secretary = secretary
    }
  },

  getters: {
    countryPrefix (state) {
      return state.countryPrefix
    },

    hospital (state) {
      return state.hospital
    },

    manager (state) {
      return state.manager
    },

    secretary (state) {
      return state.secretary
    }
  },

  actions: {
    locateUser ({ commit }) {
      return api.locateUser().then(data => {
        commit('COUNTRY', {
          country: data.country_name,
          countryCode: data.country_code2
        })
      })
    },

    setHospital ({commit}, hospital) {
      commit('HOSPITAL', hospital)
    },

    setManager ({commit}, manager) {
      commit('MANAGER', manager)
    },

    setSecretary ({commit}, secretary) {
      commit('SECRETARY', secretary)
    },

    registrationStep ({commit}, step) {
      commit('REGISTRATION_STEP', step)
    },

    async addHospital ({ commit }, data) {
      await api.addHospital(data)
    },

    createHospital ({commit, state}) {
      return api.createHospital({
        hospital: state.hospital,
        secretary: state.secretary,
        manager: state.manager
      })
    }
  }
})



// WEBPACK FOOTER //
// /src/store/index.js